import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type MultipleFilesFieldProps = {
  name: string;
  value: any;
  onChange: (value: boolean) => void;
};

const MultipleFilesField = (props: MultipleFilesFieldProps) => {
  return (
    <Autocomplete
      id="multiple-files-field"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={props.value}
      options={[true, false]}
      autoHighlight
      getOptionLabel={(option: boolean) => (option ? "True" : "False")}
      fullWidth
      disableClearable
      renderInput={(params) => (
        <EditorVisualTextField
          {...params}
          name={props.name}
          fullWidth
          label="Multiple Files"
        />
      )}
    />
  );
};

export default MultipleFilesField;
